import React from 'react';
import bgImage from 'images/interior.jpg'
import { useNavigate } from 'react-router-dom';

const Connect = () => {

    const navigate = useNavigate();

    const handleClick = () => {
        navigate(`/contact`);
    };

    return (
        <div
            className="w-full min-h-[60vh] flex items-center justify-center bg-cover bg-center px-4 py-12"
            style={{
                backgroundImage: `url(${bgImage})`,
            }}
        >
            <div className="bg-white/30 backdrop-blur-sm px-4 py-6 sm:px-8 sm:py-10 md:px-5 md:py-12 rounded-2xl shadow-xl text-center max-w-[90%] sm:max-w-xl md:max-w-2xl lg:max-w-3xl">
                <h2 className="text-xl sm:text-2xl md:text-md lg:text-2xl font-semibold text-black leading-snug">
                    Are you an <span className="font-extrabold">Architect</span> or an{' '}
                    <span className="font-extrabold">Interior Designer</span>?
                </h2>
                <p className="mt-4 text-sm sm:text-base md:text-lg text-white">
                    Let’s collaborate and bring stunning design ideas to life.
                </p>
                <button  onClick={handleClick} className="mt-6 px-6 py-2 text-sm sm:text-base  bg-black text-white rounded-full hover:bg-orange-800 transition-all duration-300 shadow-md hover:shadow-lg">
                    Contact Us
                </button>
            </div>
        </div>
    );
};

export default Connect;
